export default __webpack_public_path__ + "static/gallery-4-b1f11f3cc4d3a7888a9261fbc3db108c.jpg";